


import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
import { StoreListPage } from '../../../store-list/store-list.page';
declare var app;
@Component({
  selector: 'app-transfer-gifts-form',
  templateUrl: './transfer-gifts-form.component.html',
  styleUrls: ['./transfer-gifts-form.component.scss']
})
export class TransferGiftsFormComponent extends GridBaseCase {
  tabsIndex: any = 0;
  remarkvalue: any; //信息反馈字段
  outOrInType: string;//调出或者调入类型type
  outOrInName: string;
  month: any = new Date();
  ID: any;
  FK_TBStore_ID: any;//赠品id
  StoreName_In: any;//调入门店名称
  StoreName_Out: any;// 调出门店名称
  SignTimeEffect: any;// 日期
  FK_TBStore_ID_in: any; // 调入门店id
  FK_TBStore_ID_out: any; //调出门店id
  arrayAllList: Array<any> = new Array<any>();
  arrayfirstList: Array<any> = new Array<any>();
  pageName: string = null;
  type: any;//请求类型
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  arrayDatalist: Array<any> = []; // 数据列表总数据
  arrayDatadetail: Array<any> = []; // 数据详情展示
  arrayDatailall: Array<any> = []; // 比对显示列表
  transTime: boolean = false; // 日期控件是否显示
  PageNumber: number = 0; //左边列表
  status:any=0;
  isFlase:boolean=false;//是否可编辑
  loading:boolean=false;
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    const that = this;
    this.baseService.arrayData = [];
    this.month = this.com.getNowdate.replace(/-/g, "/").replace("T","");
    this.type = this.activaRouter.snapshot.paramMap.get('type');
    this.baseService.FixedSubmitBtn.configName = "TransferGiftsForm";
    this.baseService.FixedSubmitBtn.isShow = true;
    if (this.type == "edite") {
     
      this.activaRouter.queryParams.subscribe(queryParams => {
        console.log(queryParams, "获取的参数集合");
        this.StoreName_In = queryParams.StoreName_In || null; //调入门店id
        this.StoreName_Out = queryParams.StoreName_Out || null; // 调出门店名称
        if(queryParams.CargoDateTime){
          this.SignTimeEffect =this.month= queryParams.CargoDateTime.replace(/-/g, "/").replace("T","") || null // 日期
        }
        this.FK_TBStore_ID_in = queryParams.FK_TBStore_ID_in || null; // 调入门店id
        this.FK_TBStore_ID_out = queryParams.FK_TBStore_ID_out || null; //调出门店id
        this.ID = queryParams.ID;// 列表id
        this.status=queryParams.status;
      });
      if(this.status=="1"){
        this.baseService.FixedSubmitBtn.type = 17;//取消调货//确认提交
      }else{
        this.baseService.FixedSubmitBtn.type = 999;
        that.isFlase=true;
      }
    } else {
        this.baseService.FixedSubmitBtn.type = 25;////确认提交
    }

   
    if (!that.ID) {
      that.transTime = true;
    } else {
      that.transTime = false;
    }
  }

  ngAfterViewInit() {
    const that = this;
  }
  // 数组切换方法
  ipcConten(item, num) {
    const that = this;
    that.tabsIndex = num;
    that.arrayfirstList = item["DetailList"] || [];

  }
  EventDateTimeClick() {
    console.log("测试1");
    let that = this;
    console.log(that.month);
    let _obj = {
      value: that.month,
      format: "yyyymmdd"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.month = that.formatDate(data.value);
      console.log("测试");
    }).catch(eror => {
      console.log(eror);
    });
  }
  formatDate(date) {
    if (date) {
      let _date = new Date(date.replace(/-/g, "/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth() + 1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
    } else {
      return date;
    }
  }
  // 调出店弹窗
  async seletionModal(typeName) {
    const that = this;
    if(that.type=="add"){
      const modal = await that.modal.create({
        component: StoreListPage,
        componentProps: {
          "type": "in"
        }
      });
      await modal.present();
      // return await modal.present();
      const { data } = await modal.onWillDismiss();
      console.log(data, "onWillDismiss");
      // if (that.type == "add") {
        if(typeName=="in")
        {
          if(data&&data.info&&data.info[0]&&data.info[0].a_ID)
          {
          that.StoreName_In=data.info[0].a_Name||"--";
          that.FK_TBStore_ID_in=data.info[0].a_ID||"";
          }
        }else{
          if(data&&data.info&&data.info[0]&&data.info[0].a_ID)
          {
          that.StoreName_Out=data.info[0].a_Name||"--";
          that.FK_TBStore_ID_out=data.info[0].a_ID||"";
          }
        }
        /**
         * 如果门店进店和离店都选择好则刷新数据
         */
        if(that.FK_TBStore_ID_in && that.FK_TBStore_ID_out)
        {
          if(that.FK_TBStore_ID_in!=that.FK_TBStore_ID_out){
            that.LoadData(1);
          }else{
            that.msg.Alert("调入和调出不能是同一门店").then(res=>{
              that.arrayAllList=[];
              that.arrayfirstList=[];
              that.StoreName_In = "";

            })
            return;
          }
          
        }
    }
  }

  RemarkInput(e) {
    let that = this;
    if (e && e.target.value) {
      if (e.target.value.length > 120) {
        e.target.value = e.target.value.substr(0, 120);
        that.remarkvalue = e.target.value;
      }
    }
  }


  ChangeNum(event,allitem,item)
  {
        let that = this;
        // console.log(1);
        setTimeout(() => {
          if (event.target.value) {
            let numvalue: any = this.com.GetNumber(event.target.value);
            if (numvalue) {
              item.number= numvalue;
              event.target.value = numvalue;
            } else {
              item.number= 0;
              event.target.value = 0;
            }
          } else {
            event.target.value = null;
            item.number= 0;
          }
        }, 400);
  }
  // 根据调入门店/调出门店门店获取打调货列表
  LoadData(PageNumber) {
    let that = this;
    PageNumber = 1;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    let _dy = {};
    if(that.type=="add"){
      if (that.FK_TBStore_ID_in && that.FK_TBStore_ID_out) {
        _dy = {
          "FK_TBStore_ID_in": that.FK_TBStore_ID_in, // 调入门店id
          "FK_TBStore_ID_out": that.FK_TBStore_ID_out // 调出门店id
        };
      }else{
        that.loading=true;
        return;
      }
    }else{
      _dy["ID"]=that.ID.split("&")[0];
    }
    // else{
    //     that.msg.Alert("没有门店请进行门店选择")
    // }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if(that.type=="add"){
      body.ConfigName = "TBGiftsCargoPlanInfoGiftsSRL";
    }else{
      body.ConfigName = "TBGiftsCargoPlanInfoSRL";
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.ClientType = 1;
    body.Client.Name = "temp_content";
    body.RequestBody = JSON.stringify(_dy);
    that.http.post(app.DEFAULTURL, body).then(data => {
      // //debugger;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        if(that.type=="add"){
        data.Status.forEach(ut => {
          ut.DetailList.forEach(item => {
            item.number = 0;
          });
        });
        that.arrayAllList = data.Status || [];
        if(that.arrayAllList.length>0){
          that.arrayfirstList = data.Status[0]["DetailList"] || [];
        }
      }
      else{
        if(data.Status)
        {
          that.FK_TBStore_ID_in=data.Status["a_FK_TBStore_ID_in"]||null;
          that.FK_TBStore_ID_out=data.Status["a_FK_TBStore_ID_out"]||null;
        }
        //编辑修改加载loading
        if(data.Status&&data.Status["infolist"])
        {
          let edit_data=data.Status["infolist"];
          edit_data.forEach(ut => {
            ut.DetailList.forEach(item => {
              if(item["a_Cargo"])
              {
                item.number = item["a_Cargo"];
              }else{
                item.number = 0;
              }
            });
          });
          that.arrayAllList = edit_data || [];
          that.arrayfirstList = edit_data[0]["DetailList"] || [];
        }
      }
      } else {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  //提交按钮
  EventSubmitClick(btnType: any = true) {
    const that=this;
    let obj:any={};
    if (btnType) {
      obj["CargoState"]=1;
    }
    else {
      obj["CargoState"]=3;//驳回
    }
    if(that.ID){
      obj["ID"]=that.ID.split("&")[0];
    }
    obj["FK_TBStore_ID_in"]=that.FK_TBStore_ID_in;
    obj["FK_TBStore_ID_out"]=that.FK_TBStore_ID_out;
    obj["CargoDateTime"]=that.month.replace(/-/g, "/").replace("T","");
    obj["list"]=new Array<any>();
    if(that.arrayAllList.length<=0){
      that.msg.Alert("必须选择赠品");
      return;
    }
    let _array:Array<any> = new Array<any>();
    that.arrayAllList.forEach(item=>{
      item.DetailList.forEach(prod => {
        if(prod.number || prod.ID){
          _array.push(prod);
        }
      });
    });
    if(_array.length<=0){
      that.msg.Alert("未调入/调出任何赠品");
      return;
    }
    _array.forEach(item=>{
      let _object:any={};
      // if (this.type == "edite") {
      //   _object["FK_TBGift_ID"]=item.ID;
      // }
      if(item.a_ID){
        _object["ID"]=item.a_ID;
      }
      _object["FK_TBGift_ID"]=item.a_FK_TBGift_ID;
      _object["Cargo"]=item.number;
      obj.list.push(_object);
    });
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if(that.type=="add"){
      body.ConfigName = "TBGiftsCargoPlanInfoAddUpdateSRL";
      body.OpType = "add";
    }else{
      body.ConfigName = "TBGiftsCargoPlanInfoAddUpdateSRL";
      body.OpType = "edite";
    }
  
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify(obj);
    that.msg.Confirm("确认提交吗？","取消","确定").then(res=>{
      if(res){
        that.msg.Loading("请稍后...").then(loads => {
          that.http.post(app.DEFAULTURL, body).then(data => {
            setTimeout(function(){
              loads.dismiss();
            },100);
            if (data.ResponseMessage.Success) {
             that.msg.Alert("操作成功！").then(res=>{
              that.com.goBack(false);
             });
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          }).catch(err => {
            loads.dismiss();
            that.msg.Alert("网络异常，请稍后再试！");
          });
        });
      }
    });
  }

  
}

